<mat-sidenav-container class="vscode-layout">
  <!-- SIDEBAR IZQUIERDO -->
  <mat-sidenav mode="side" opened class="sidebar-left">
    <button mat-icon-button (click)="togglePanel('escritos')">
      <mat-icon>description</mat-icon>
    </button>
    <button mat-icon-button (click)="togglePanel('plantillas')">
      <mat-icon>article</mat-icon>
    </button>
    <button mat-icon-button (click)="togglePanel('busqueda')">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-icon-button (click)="togglePanel('historial')">
      <mat-icon>history</mat-icon>
    </button>
  </mat-sidenav>

  <!-- CONTENIDO PRINCIPAL -->
  <mat-sidenav-content>

    <!-- PANEL DINÁMICO TIPO OVERLAY -->
    <div *ngIf="panelAbierto" class="panel-navegacion">
      <ng-container [ngSwitch]="panelAbierto">
        <!-- Escritos -->
        <div *ngSwitchCase="'escritos'">
          <p>Listado de escritos</p>
          <!-- <app-arbol-escritos [filtro]="filtroEscritos" (abrirEscrito)="abrirEscrito($event)"></app-arbol-escritos> -->
        </div>

        <!-- Plantillas -->
        <div *ngSwitchCase="'plantillas'">
          <p>Listado de plantillas</p>
          <!-- <app-arbol-plantillas [filtro]="filtroPlantillas" (abrirPlantilla)="abrirPlantilla($event)"></app-arbol-plantillas> -->
        </div>

        <!-- Búsqueda -->
        <div *ngSwitchCase="'busqueda'">
          <p>Búsqueda</p>
          <!-- <app-busqueda-texto></app-busqueda-texto> -->
        </div>

        <!-- Historial -->
        <div *ngSwitchCase="'historial'">
          <p>Historial</p>
          <!-- <app-historial-cambios [escrito]="escritoSeleccionado"></app-historial-cambios> -->
        </div>
      </ng-container>
    </div>

    <!-- ZONA PRINCIPAL DE EDICIÓN -->
    <div class="main-editor">
      <mat-tab-group [(selectedIndex)]="selectedTabIndex">
        <mat-tab *ngFor="let escrito of escritosAbiertos; let i = index" [label]="escrito.titulo">
          <ng-template mat-tab-label>
            {{ escrito.titulo }}
            <button mat-icon-button (click)="guardarEscrito(escrito)">
              <mat-icon>save</mat-icon>
            </button>
            <button mat-icon-button (click)="cerrarEscrito(i)">
              <mat-icon>close</mat-icon>
            </button>
          </ng-template>

          <!-- ZONA DE EDICIÓN -->
          <editor [contenido]="escrito.contenido" (actualizar)="actualizarContenido(i, $event)"></editor>
        </mat-tab>
      </mat-tab-group>
    </div>

  </mat-sidenav-content>
</mat-sidenav-container>
